import { LocationOn } from "@mui/icons-material";
import { Card, Box, Typography, Avatar } from "@mui/material";
import { styled } from "@mui/system";

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(3),
  cursor: "pointer",
  transition: "all 0.3s ease",
  border: "2px solid",
  borderColor: theme.palette.primary.light,
  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  background: "none",
  textAlign: "center",
  "&:hover": {
    boxShadow: theme.shadows[4],
    transform: "translateY(-4px)",
  },
}));

const LogoContainer = styled(Box)(({ theme }) => ({
  width: 64,
  height: 64,
  backgroundColor: theme.palette.grey[200],
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "transform 0.3s ease",
  "&:hover": {
    transform: "scale(1.05)",
  },
}));

const Hotel = ({ id, name, location, logo, onClick }) => {
  return (
    <StyledCard onClick={onClick}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        textAlign="center"
        gap={2}
      >
        {/* Hotel Logo */}
        <LogoContainer>
          {
            <Avatar
              src={logo}
              alt={name}
              sx={{
                width: 66,
                height: 66,
                objectFit: "contain",
              }}
            />
          }
        </LogoContainer>

        {/* Hotel Name */}
        <Typography
          variant="h6"
          fontWeight="medium"
          sx={{
            transition: "color 0.3s ease",
            "&:hover": {
              color: "primary.main",
            },
            fontSize: {
              xs: "0.7rem", // Smaller on mobile
              sm: "1rem", // Normal on larger screens
            },
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {name}
        </Typography>

        {/* Hotel Location */}
        <Box display="flex" alignItems="center" gap={1} color="text.secondary">
          <LocationOn fontSize="small" />
          <Typography variant="body2">{location}</Typography>
        </Box>
      </Box>
    </StyledCard>
  );
};

export default Hotel;
